export default  [
                      {
                      "name": "customer account|type",
                      "key": "customerAccount",
                      "isSelected": true,
                      "order": 1,
                      "isDefault": true
                      },
                      {
                      "name": "cusip/desc",
                      "key": "cusipDesc",
                      "isSelected": true,
                      "order": 2,
                      "isDefault": true
                      },
                      {
                      "name": "coupon",
                      "key": "coupon",
                      "isSelected": true,
                      "order": 3,
                      "isDefault": true
                      },
                      {
                      "name": "maturity date/call date",
                      "key": "maturAndcallDate",
                      "isSelected": true,
                      "order": 4,
                      "isDefault": true
                      },
                      {
                      "name": "moody's /s&p rating",
                      "key": "rating",
                      "isSelected": true,
                      "order": 5,
                      "isDefault": true
                      },
                      {
                      "name": "insurer",
                      "key": "bondInsurer",
                      "isSelected": true,
                      "order": 6,
                      "isDefault": false
                      },
                      {
                      "name": "bought",
                      "key": "boughtDate",
                      "isSelected": true,
                      "order": 7,
                      "isDefault": false
                      },
                      {
                      "name": "cost",
                      "key": "cost",
                      "isSelected": true,
                      "order": 8,
                      "isDefault": false
                      },
                      {
                      "name": "closingPx",
                      "key": "closingPx",
                      "isSelected": true,
                      "order": 9,
                      "isDefault": false
                      },
                      {
                      "name": "qty",
                      "key": "quantity",
                      "isSelected": true,
                      "order": 10,
                      "isDefault": false
                      },
                      {
                      "name": "avlb qty",
                      "key": "remainQuantity",
                      "isSelected": true,
                      "order": 11,
                      "isDefault": false
                      },
                      {
                        "name": "Gain Loss Price",
                        "key": "gainLossPrice",
                        "isSelected": true,
                        "order": 11,
                        "isDefault": false
                      },
                      {
                        "name": "Gain Loss Percentage",
                        "key": "gainLossPercentage",
                        "isSelected": true,
                        "order": 11,
                        "isDefault": false
                        },
                        {
                            "name": "State",
                            "key": "state",
                            "isSelected": true,
                            "order": 11,
                            "isDefault": false
                            },
                        {
                            "name": "Cash Available",
                            "key": "cashAvailable",
                            "isSelected": true,
                            "order": 11,
                            "isDefault": false
                            }
                    
                        
                  
                ]